/**
 * api config
 */
export const API_ADDRESS = process.env.REACT_APP_API_ADDRESS; // 未清理过的API前缀
export const API_DATA_ADDRESS = process.env.REACT_APP_API_DATA_ADDRESS; // 未清理过的API前缀
const CNABS_API_ADDRESS = `${API_ADDRESS}/apigateway/cnabs`; // 清理过的API前缀
const CNABS_API_DATA_ADDRESS = `${API_DATA_ADDRESS}/api`; // 清理过的API前缀
export const PUBLISH_PATH = process.env.REACT_APP_PUBLISH_PATH || '/';
const UPLOAD_API_ADDRESS = process.env.REACT_APP_FILE_SERVER; // 文件服务器前缀

export const ACCOUNT_SERVER = process.env.REACT_APP_ACCOUNT_SERVER; // 账号相关的api前缀
export const CALC_SERVER = process.env.REACT_APP_CALC_SERVER; // 计算器相关api前缀
// 全局
export const GlobalApi = {
  menu: `${CNABS_API_ADDRESS}/global/menu`, // 菜单
  search: `${CNABS_API_ADDRESS}/global/search/filter`, // 全部搜索
  searchOrganization: `${CNABS_API_ADDRESS}/global/search/filter/organization`, // 搜索机构（无权限接口）
  searchSecurity: `${CALC_SERVER}/calc/search`, //  搜索多选证券（债券计算器）
  searchByPage: `${CNABS_API_ADDRESS}/global/search/pager`, // 分页搜索
  captcha2: `${ACCOUNT_SERVER}/api/global/captcha`, // 数字验证码
  captcha: `${CNABS_API_ADDRESS}/global/captcha?type=`, // 数字验证码
  feedback: `${CNABS_API_ADDRESS}/global/feedback`, // 意见反馈
  feedbackWebApi: `${CNABS_API_ADDRESS}/global/feedback/webapi`, //  api模块的反馈
  feedbackAnonymous: `${CNABS_API_ADDRESS}/global/feedback/anonymous`, // 匿名意见反馈
  uploadUrl: `${UPLOAD_API_ADDRESS}/common/upload/cnabs`, // 上传文件
  downloadUrl: `${UPLOAD_API_ADDRESS}/common/download/cnabs/`, // 下载文件
  uploadImgUrl: `${UPLOAD_API_ADDRESS}/common/uploadimg/cnabs`, // 上传图片
  downloadImgUrl: `${UPLOAD_API_ADDRESS}/common/downloadimg/cnabs/`, // 下载图片
  previewImage: code => `${UPLOAD_API_ADDRESS}/common/downloadimg/cnabs/${code}`, // 预览图片
  downloadFiles: `${UPLOAD_API_ADDRESS}/common/download/cnabs/`, // 下载文件 (文件服务器)
  filter: `${CNABS_API_ADDRESS}/global/filter`, // 过滤
  dealTypeFilter: `${CNABS_API_ADDRESS}/global/deal-type-filter`, // 详细过滤
  downloadFile: `${CNABS_API_ADDRESS}/global/download?guid=`, // 全局下载
  feedbackHome: `${CNABS_API_ADDRESS}/global/feedback/home`, // 桌面端申请
  businessType: `${CNABS_API_ADDRESS}/global/business-type`, // 业务类型
  downChartData: `${CNABS_API_ADDRESS}/global/chart-download`, // 下载图表数据
  // downPngChartData: `${CNABS_API_ADDRESS}/global/chart-download-img`, // 下载PNG图表数据
  chartZoom: `${CNABS_API_ADDRESS}/global/chart-zoom`, // 图表放大功能使用统计
  messageUnreadCount: `${CNABS_API_ADDRESS}/account/internal-message/unread/count`, // 未读消息数量

  inviteEmailList: `${CNABS_API_ADDRESS}/account/invite/email/list`, // 邮箱邀请
  inviteEmailFile: `${CNABS_API_ADDRESS}/account/invite/email/file`, // 通讯录邀请
  invitePopup: `${CNABS_API_ADDRESS}/account/invite/popup`, // 邀请弹框显示状态

  pointAdd: `${CNABS_API_ADDRESS}/global/point-add`, // 分享abs日报或专家履历，加积分
  voteSend: `${CNABS_API_ADDRESS}/account/vote/send`, // 产品、机构，专家投票
  voteCount: `${CNABS_API_ADDRESS}/account/vote/count`, // 产品、机构，专家获取当前得票数和状态

  searchDownload: `${CNABS_API_ADDRESS}/global/search/download`, // 搜索页产品、证券、机构的下载

  pageLog: `${CNABS_API_ADDRESS}/account/invite/business/check` // 用于用户点击页面的统计
};

// 产品
export const ProductApi = {
  fileList: `${CNABS_API_ADDRESS}/deal/document/list`, // 产品文档
  reitsDocs: `${CNABS_API_ADDRESS}/reits/docs`, // 产品文档
  fileListDownload: `${CNABS_API_ADDRESS}/deal/document/download`, // 产品文档下载

  structureImage: `${CNABS_API_ADDRESS}/deal/structure/trade-img`, // 交易结构图片
  reitsStructureImage: `${CNABS_API_ADDRESS}/reits/structure/trade-img`, // 交易结构图片
  paymentModel: `${CNABS_API_ADDRESS}/deal/structure/payment-model/chart`, // 偿付模型
  internalCreditList: `${CNABS_API_ADDRESS}/deal/structure/internal-credit/list`, // 内部信用增级方式
  externalCreditList: `${CNABS_API_ADDRESS}/deal/structure/external-credit/list`, // 外部信用增级方式

  dealList: `${CNABS_API_ADDRESS}/deal/deal-list/pager`, // 产品列表

  dealPerfect: `${CNABS_API_ADDRESS}/deal/perfect`, // 数据完善
  dealCore: `${CNABS_API_ADDRESS}/deal/core`, // 关注产品
  dealFollow: `${CNABS_API_ADDRESS}/deal/follow`, // 关注产品
  dealExport: `${CNABS_API_ADDRESS}/deal/export`, // 下载产品
  dealCloudmodel: `${CNABS_API_ADDRESS}/deal/cloud-model/download`, // 下载产品云模型

  detail: `${CNABS_API_ADDRESS}/deal/detail`, // 基本要素的详情
  paymentChart: `${CNABS_API_ADDRESS}/deal/security/payment/chart`, // 证券偿付图
  structureChart: `${CNABS_API_ADDRESS}/deal/security/structure/chart`, // 证券结构图
  paymentList: `${CNABS_API_ADDRESS}/deal/analysis/security/payment/list`, // 证券偿付列表（含列表）
  computationResult: `${CNABS_API_ADDRESS}/deal/analysis/security/static-results`, // 证券结果分析、计算结果列表
  trendOfNetValueChart: `${CNABS_API_ADDRESS}/reits/netvalues`, // 净值走势情况图
  priceTradeChart: `${CNABS_API_ADDRESS}/reits/tradedata`, // K线图

  scenarioParmsList: `${CNABS_API_ADDRESS}/deal/analysis/security/payment/list`, // 情景参数列表
  assetPoolPaymentTrendChart: `${CNABS_API_ADDRESS}/deal/analysis/asset/payment/chart`, // 资产池偿付走势图
  ICOCTrendChart: `${CNABS_API_ADDRESS}/deal/analysis/asset/icoc/chart`, // IC、OC走势图
  assetPoolInterestRateTrendChart: `${CNABS_API_ADDRESS}/deal/analysis/asset/interest/chart`, // 资产池利率分布走势图

  assetDistribute: `${CNABS_API_ADDRESS}/deal/asset/distribute`, // 资产池分布
  assetRiskList: `${CNABS_API_ADDRESS}/deal/asset/risk/list`, // 资产池风险分析
  assetChangeList: `${CNABS_API_ADDRESS}/deal/asset/change/list`, // 资产池变化情况
  assetPoolList: `${CNABS_API_ADDRESS}/reits/assets/list`, // 资产池变化情况
  assetDetail: `${CNABS_API_ADDRESS}/deal/asset/detail`, // 原始资产池
  assetPaymentChart: `${CNABS_API_ADDRESS}/deal/analysis/asset/payment/chart`, // 资产池偿付走势图
  assetPrepaymentChart: `${CNABS_API_ADDRESS}/deal/asset/prepayment/chart`, // 资产池累计提前偿还率走势图
  assetDefaultChart: `${CNABS_API_ADDRESS}/deal/asset/default/chart`, // 资产池累计违约率走势图

  sameSubjectNpl: `${CNABS_API_ADDRESS}/deal/originator/same-subject-npl/chart`, // 同主体实际回收率对比 走势图
  sigleDealNpl: `${CNABS_API_ADDRESS}/deal/originator/sigle-deal-npl/chart`, // 单个产品预测回收和实际回收对比 走势图

  assetChangeLisExport: `${CNABS_API_ADDRESS}/deal/asset/change/list/export`, // 资产池变化情况下载
  assetDelinquencyListExport: `${CNABS_API_ADDRESS}/deal/asset/delinquency/list/export`, // 拖欠情况下载
  assetRiskListExport: `${CNABS_API_ADDRESS}/deal/asset/risk/list/export`, // 违约与早偿率下载

  securityList: `${CNABS_API_ADDRESS}/deal/security/list`, // 产品要素的证券列表以及产品证券的列表
  securityDetailList: `${CNABS_API_ADDRESS}/deal/security-detail`, // 产品证券的列表(原接口securityList换为此接口)

  publishCount: `${CNABS_API_ADDRESS}/deal/originator/issue-statistics/chart`, // ABS发行统计图
  bondFutureRepayCount: `${CNABS_API_ADDRESS}/deal/originator/public-bond-statistics/chart`, // ABS与公开发行债券未来偿付统计图
  financialQuota: `${CNABS_API_ADDRESS}/deal/originator/financial-target/chart`, // 财务指标图
  publishCountDownload: `${CNABS_API_ADDRESS}/deal/originator/issue-statistics/export`, // ABS发行统计分布图下载
  bondFutureRepayCountDownload: `${CNABS_API_ADDRESS}/deal/originator/public-bond/export`, // ABS与公开发行债券未来偿付统计分布图下载
  financialQuotaDownload: `${CNABS_API_ADDRESS}/deal/originator/financial-target/export`, // 财务指标分布图下载
  originatorDealDetail: `${CNABS_API_ADDRESS}/deal/originator/deal/detail`, // 产品主体-主体信息

  scenarioList: `${CNABS_API_ADDRESS}/deal/scenario/list`, // 情景分析列表
  dealSecurityListPager: `${CNABS_API_ADDRESS}/deal/security-list/pager`, // 证券列表
  dealSecurityListExport: `${CNABS_API_ADDRESS}/deal/security-list/export`, // 下载证券列表
  dealListPager: `${CNABS_API_ADDRESS}/deal/deal-list/pager`, // 产品列表
  dealListExport: `${CNABS_API_ADDRESS}/deal/deal-list/export`, // 下载产品列表
  dealPipelinePager: `${CNABS_API_ADDRESS}/deal/pipeline/pager`, // 过会产品列表
  dealPipelineExport: `${CNABS_API_ADDRESS}/deal/pipeline/export`, // 过会产品列表下载
  dealPipelineSchedule: `${CNABS_API_ADDRESS}/deal/pipeline/schedule`, // 过会产品流程图
  reitsPager: `${CNABS_API_ADDRESS}/reits/pager`, // reits专区列表
  reitsOverseasPager: `${CNABS_API_ADDRESS}/reits/pager`, // 海外reits专区列表

  monteCarloAnalysisCalculate: `${CNABS_API_ADDRESS}/deal/monte-carlo-analysis/calculate`, // 蒙特卡洛分析

  compareList: `${CNABS_API_ADDRESS}/deal/compare/list`, // 产品对比-产品列表
  compareResult: `${CNABS_API_ADDRESS}/deal/compare/result`, // 产品对比-对比结果

  privateDocumentListPager: `${CNABS_API_ADDRESS}/deal/document/list/pager`, // 文档列表
  userGroupList: `${CNABS_API_ADDRESS}/deal/document/user-group/list`, // 用户组列表
  userGroupUpdate: `${CNABS_API_ADDRESS}/deal/document/user-group/update`, // 创建/更新用户组
  userGroupDelete: `${CNABS_API_ADDRESS}/deal/document/user-group/delete`, // 删除用户组
  userGroupUserAdd: `${CNABS_API_ADDRESS}/deal/document/user-group/user/add`, // 新增小组用户
  userGroupUserDelete: `${CNABS_API_ADDRESS}/deal/document/user-group/user/delete`, // 删除小组用户
  userGroupUserList: `${CNABS_API_ADDRESS}/deal/document/user-group/user/list`, // 获取小组用户列表
  documentDownload: `${CNABS_API_ADDRESS}/deal/document/manage/download`, // 下载文档

  documentList: `${CNABS_API_ADDRESS}/deal/document/manage/list`, // 获取文档列表
  documentUpload: `${CNABS_API_ADDRESS}/deal/document/manage/upload`, // 上传文档
  documentDelete: `${CNABS_API_ADDRESS}/deal/document/manage/delete`, // 删除文档
  documentUpdate: `${CNABS_API_ADDRESS}/deal/document/manage/update`, // 修改文档

  documentAuthorizationShow: `${CNABS_API_ADDRESS}/deal/document/manage/authorization_show`, // 授权文档显示
  documentAuthorizationDelete: `${CNABS_API_ADDRESS}/deal/document/manage/authorization_delete`, // 授权文档删除
  documentAuthorizationSearch: `${CNABS_API_ADDRESS}/deal/document/manage/authorization_search`, // 查看文档
  documentPayDate: `${CNABS_API_ADDRESS}/deal/document/manage/paydate`, // 支付日期
  judgeDocumentName: `${CNABS_API_ADDRESS}/deal/document/manage/judge_document_name`, // 文档判重
  documentManageIs_authorized: `${CNABS_API_ADDRESS}/deal/document/manage/is_authorized`, // 权限判断

  organizationList: `${CNABS_API_ADDRESS}/deal/deal-agencys`, // 参与机构
  reitsOrganizations: `${CNABS_API_ADDRESS}/reits/organizations`, // 参与机构
  reitsInvestorList: `${CNABS_API_ADDRESS}/reits/subRedem`, // 公募战略配售投资者
  dealExperts: `${CNABS_API_ADDRESS}/deal/deal-experts`, // 相关专家页面列表
  reitsExperts: `${CNABS_API_ADDRESS}/reits/experts`, // 相关专家页面列表

  dealsCoupon: `${CNABS_API_ADDRESS}/organization/participate/deals/coupon`, // 获取发行利率‘点’数据
  dealsIssuerate: `${CNABS_API_ADDRESS}/organization/participate/deals/issuerate`, // 获取发行利差‘点’数据
  yieldCurve: `${CNABS_API_ADDRESS}/organization/yieldcurve`, // 获取基准利率曲线
  couponDownload: `${CNABS_API_ADDRESS}/organization/participate/deals/coupon/export`, // 发行利率分布图下载
  issuerateDownload: `${CNABS_API_ADDRESS}/organization/participate/deals/issuerate/export`, // 发行利差分布图下载

  reitsDetail: `${CNABS_API_ADDRESS}/reits/detail`, // reits专区基本要素的详情
  reitsCore: `${CNABS_API_ADDRESS}/reits/core`, // reits专区header头部信息

  financialData: `${CNABS_API_ADDRESS}/reits/financial-reportdata`, // reits专区财务数据
  assetDates: `${CNABS_API_ADDRESS}/reits/assets/dates` // reits专区 资产池 数据
};

// 机构
export const OrganizantionApi = {
  organizationCore: `${CNABS_API_ADDRESS}/organization/core`, // 机构核心
  organizationLogoUpdate: `${CNABS_API_ADDRESS}/organization/detail/filecode/update`, // 更新机构logo
  organizationInfoUpdate: `${CNABS_API_ADDRESS}/organization/detail/info/update`, // 更新机构信息
  organizationDetail: `${CNABS_API_ADDRESS}/organization/detail`, // 机构信息详情
  expertAdminApply: `${CNABS_API_ADDRESS}/organization/expert-admin/apply`, // 机构管家申请
  rankList: `${CNABS_API_ADDRESS}/organization/rank/list`, // 机构排名列表和图表
  rankExport: `${CNABS_API_ADDRESS}/organization/rank/export`, // 机构排名数据下载
  awards: `${CNABS_API_ADDRESS}/organization/awards/list`, // 机构奖项
  expert: `${CNABS_API_ADDRESS}/organization/expert/pager`, // 机构专家
  articles: `${CNABS_API_ADDRESS}/organization/articles/pager`, // 机构文章
  updateIntroduction: `${CNABS_API_ADDRESS}/organization/detail/introduction/update`, // 机构介绍更新
  awardUpdate: `${CNABS_API_ADDRESS}/organization/award/update`, // 机构奖项更新
  awardDelete: `${CNABS_API_ADDRESS}/organization/award/delete`, // 机构奖项删除
  articleUpdate: `${CNABS_API_ADDRESS}/organization/article/update`, // 机构文章更新
  articleDelete: `${CNABS_API_ADDRESS}/organization/article/delete`, // 机构文章删除
  dealIssueStatisticChart: `${CNABS_API_ADDRESS}/organization/deal/issue/statistic/chart`, // 机构参与产品发行统计图
  roleRankChart: `${CNABS_API_ADDRESS}/organization/role/rank/chart`, // 机构角色市场排名
  dealDealTypeChart: `${CNABS_API_ADDRESS}/organization/deal/dealtype/chart`, // 机构参与产品基础资产类型统计
  dealRoleChart: `${CNABS_API_ADDRESS}/organization/deal/role/chart`, // 机构参与产品角色统计
  participateDealListExport: `${CNABS_API_ADDRESS}/organization/participate/deal/list/export`, // 参与项目列表下载
  participateDealList: `${CNABS_API_ADDRESS}/organization/participate/deal/list`, // 参与项目列表下载
  managerCheck: `${CNABS_API_ADDRESS}/organization/manager/check`, // 参与项目列表下载
  dealCompareResult: `${CNABS_API_ADDRESS}/deal/compare/result`, // 对比结果

  certificationList: `${CNABS_API_ADDRESS}/organization/expert/certification/list`, // 获取专家列表
  certificationUpdate: `${CNABS_API_ADDRESS}/organization/expert/certification/update`, // 认证操作

  organizationBaseinfo: `${CNABS_API_ADDRESS}/organization/baseinfo`, // 机构基本信息

  articlesExport: `${CNABS_API_ADDRESS}/organization/articles/download` // 机构文章下载
};

// 投资
export const InvestmentApi = {
  securityList: `${CNABS_API_ADDRESS}/investment/pager`, // 证券列表
  subscribeSecurity: `${CNABS_API_ADDRESS}/investment/subscribe`, // 证券订阅/取消
  publicTrade: `${CNABS_API_ADDRESS}/investment/publish`, // 发布交易信息
  securityDetail: `${CNABS_API_ADDRESS}/investment/security/detail`, // 证券交易详情
  portfolioPager: `${CNABS_API_ADDRESS}/portfolio/pager`, // 组合列表
  portfolioUpdate: `${CNABS_API_ADDRESS}/portfolio/update`, // 创建、更新组合
  portfolioDelete: `${CNABS_API_ADDRESS}/portfolio/delete`, // 删除组合
  portfolioEmailNoticeUpdate: `${CNABS_API_ADDRESS}/portfolio/mailRemind/update`, // 更新邮件通知请求
  portfolioSecurityPager: `${CNABS_API_ADDRESS}/portfolio/security/pager`, // 组合证券
  portfolioSecurityDelete: `${CNABS_API_ADDRESS}/portfolio/security/delete`, // 删除组合证券
  portfolioSecurityCreate: `${CNABS_API_ADDRESS}/portfolio/security/create`, // 添加组合证券信息
  portfolioSecurityUpdate: `${CNABS_API_ADDRESS}/portfolio/security/update`, // 编辑组合证券信息

  portfolioSecurityCashFlowDownload: `${CNABS_API_ADDRESS}/portfolio/cashflow/list/download`, // 组合证券现金流下载
  portfolioSecurityCashFlowPager: `${CNABS_API_ADDRESS}/portfolio/cashflow/list`, // 组合证券现金流
  portfolioCashFlowDetailDownload: `${CNABS_API_ADDRESS}/portfolio/cashflow/detail/download`, // 组合现金流详情下载
  portfolioCashFlowDetailPager: `${CNABS_API_ADDRESS}/portfolio/cashflow/detail`, // 现金流明细

  portfolioNewsPager: `${CNABS_API_ADDRESS}/portfolio/security/news/pager`, // 组合新闻
  portfolioSecurityChart: `${CNABS_API_ADDRESS}/portfolio/security/chart`, // 组合新闻

  searchSecurityList: `${CNABS_API_ADDRESS}/pricing/securitypricingresult/detail`, // Wal查询
  searchSecurityListDownLoad: `${CNABS_API_ADDRESS}/pricing/securitypricingresult/download`, // Wal查询结果下载
  secondaryMarketApply: `${CNABS_API_ADDRESS}/trade/secondary-market/apply`, // 上传名片
  openAuthorize: `${CNABS_API_ADDRESS}/trade/secondary-market/authorize`, // 报价开通权限

  portfolioDownload: `${CNABS_API_ADDRESS}/portfolio/security/export`, // 组合证券下载

  portfolioDemoDownload: `${CNABS_API_ADDRESS}/portfolio/download/upload-demo`, // 组合证券模板下载
  portfolioUpload: `${CNABS_API_ADDRESS}/portfolio/upload`, // 上传文件
  portfolioAddForm: `${CNABS_API_ADDRESS}/portfolio/add/from-file`, // 上传批量数据

  historyQuoteList: `${CNABS_API_ADDRESS}/secondary-market/quote/history-quote/pager`, // 历史报价列表+分页
  historyTradeList: `${CNABS_API_ADDRESS}/secondary-market/quote/history-trade/pager`, // 历史成交列表+分页
  historyQuoteExport: `${CNABS_API_ADDRESS}/secondary-market/quote/history-quote/export`, // 历史报价列表下载
  historyTradeExport: `${CNABS_API_ADDRESS}/secondary-market/quote/history-trade/export`, // 历史成交列表下载
  // tradingCircleList: `${CNABS_API_ADDRESS_QUOTE}/https/secondary-market/quote/grow`, // 旧的实时报价信息列表
  tradingCircleList: `${CNABS_API_ADDRESS}/secondary-market/quote/list`, // 新的实时报价信息列表
  quoteAdd: `${CNABS_API_ADDRESS}/secondary-market/quote/add`, // 我要报价-提交报价
  tradersByOrgId: `${CNABS_API_ADDRESS}/secondary-market/quote/traders/by-orgid`, // 实时报价信息-获取某条报价的交易员信息
  showQuoteStatus: `${CNABS_API_ADDRESS}/secondary-market/quote/trader-info/by-userid`, // 获取报价相关操作权限
  myQuotePaper: `${CNABS_API_ADDRESS}/secondary-market/quote/myquote/pager`, // 我的报价
  statusUpdate: `${CNABS_API_ADDRESS}/secondary-market/quote/status/update`, // 修改状态
  downloadQuoteDemo: `${CNABS_API_ADDRESS}/secondary-market/quote/download/quotefile-demo`, // 下载报价模板
  quoteUpload: `${CNABS_API_ADDRESS}/secondary-market/quote/upload`, // 导入报价
  addQuoteFile: `${CNABS_API_ADDRESS}/secondary-market/quote/add/from-file`, // 提交报价（文件上传）
  tradeByQuoteId: `${CNABS_API_ADDRESS}/secondary-market/quote/trade/by-quoteId`, // 提交报价（文件上传）
  calcInit: `${CALC_SERVER}/calc/init`, // 债券计算器-获取热门搜索、最近搜索、产品分类选项、情景列表
  calcSearch: `${CALC_SERVER}/calc/note`, // 债券计算器-获取搜索后相关证券信息
  calcSearchAddHistory: `${CALC_SERVER}/calc/searchhistory`, // 添加搜索历史记录
  calcSaveScenario: `${CALC_SERVER}/calc/scenario`, // 债券计算器-保存情景
  calcPricing: `${CALC_SERVER}/calc/pricing` // 债券计算器-计算
};

// 账号
export const AccountApi = {
  login: `${ACCOUNT_SERVER}/api/account/login`, // 登录
  loginOuth: `${CNABS_API_ADDRESS}/account/login/oauth`, // 登录
  logout: `${CNABS_API_ADDRESS}/account/logout`, // 退出登录
  oauthLogout: `${ACCOUNT_SERVER}/api/account/logout`, // 退出登录
  auth: `${CNABS_API_ADDRESS}/account/auth`, // 获取权限

  resetPassword: `${CNABS_API_ADDRESS}/account/login/password/reset`, // 重置密码
  registerDomestic: `${CNABS_API_ADDRESS}/account/register`, // 国内注册
  registerOverseas: `${CNABS_API_ADDRESS}/account/register/card`, // 国外注册
  getRegisterCaptcha: `${CNABS_API_ADDRESS}/account/reg/capt/dx`, // 获取注册验证码
  getResetPasswordCaptcha: `${CNABS_API_ADDRESS}/account/login/password/reset/sms/send`,
  checkRegisterCaptcha: `${CNABS_API_ADDRESS}/account/register/mobile-vcode/check`, // 国内注册-手机号验证码是否匹配
  checkResetPasswordCaptcha: `${CNABS_API_ADDRESS}/account/login/password/reset/sms/check`, // 国内注册-手机号验证码是否匹配
  checkUserName: `${CNABS_API_ADDRESS}/account/username/check`, // 检查用户名是否重复
  modifypwd: `${CNABS_API_ADDRESS}/account/profile/password/change`, // 修改密码
  wechatLogin: `${CNABS_API_ADDRESS}/account/login/wechat`, // 微信登录
  wechatBind: `${CNABS_API_ADDRESS}/account/wechat/bind`, // 微信绑定
  modifyMobile: `${CNABS_API_ADDRESS}/account/mobile/update`, // 重置手机号
  getResetPwdCaptcha: `${CNABS_API_ADDRESS}/account/capt/dx`, // 重置手机号

  followDealPager: `${CNABS_API_ADDRESS}/account/follow/deal/pager`, // 	关注产品列表
  personalDetail: `${CNABS_API_ADDRESS}/expert/resume/detail`, // 	获取专家详情 获取个人详情
  followFriendPager: `${CNABS_API_ADDRESS}/account/follow/friend/pager`, // 我关注的专家
  followFollowerPager: `${CNABS_API_ADDRESS}/account/follow/follower/pager`, // 关注我的专家
  followDealUpdate: `${CNABS_API_ADDRESS}/account/follow/deal/update`, // 添加（取消）关注
  followExpertUpdate: `${CNABS_API_ADDRESS}/account/follow/expert/update`, // 更新专家关注
  introduceUpdate: `${CNABS_API_ADDRESS}/account/profile/introduce/update`, // 	个人简介

  absProject: `${CNABS_API_ADDRESS}/expert/abs-project/pager`, // 	ABS项目(带分页)
  absProjectUpdate: `${CNABS_API_ADDRESS}/account/profile/abs-project/update`, // 	ABS项目
  absProjectDelete: `${CNABS_API_ADDRESS}/account/profile/abs-project/delete`, // 	删除ABS项目
  otherProject: `${CNABS_API_ADDRESS}/expert/other-project/pager`, //  其他项目经历(带分页)
  otherProjectUpdate: `${CNABS_API_ADDRESS}/account/profile/other-project/update`, //  编辑其他项目经历
  otherProjectDelete: `${CNABS_API_ADDRESS}/account/profile/other-project/delete`, //  删除其他项目经历

  awardsUpdate: `${CNABS_API_ADDRESS}/account/profile/awards/update`, // 	奖项荣誉
  awardsDelete: `${CNABS_API_ADDRESS}/account/profile/awards/delete`, // 	删除奖项荣誉
  dutyUpdate: `${CNABS_API_ADDRESS}/account/profile/post/update`, // 	其他职务
  dutyDelete: `${CNABS_API_ADDRESS}/account/profile/post/delete`, // 	删除其他职务
  activityUpdate: `${CNABS_API_ADDRESS}/account/profile/activity/update`, // 	近期活动
  activityDelete: `${CNABS_API_ADDRESS}/account/profile/activity/delete`, // 	删除活动
  worksUpdate: `${CNABS_API_ADDRESS}/account/profile/work/update`, // 	工作经历
  worksDelete: `${CNABS_API_ADDRESS}/account/profile/work/delete`, // 	删除工作经历
  educationUpdate: `${CNABS_API_ADDRESS}/account/profile/education/update`, // 	教育经历
  educationDelete: `${CNABS_API_ADDRESS}/account/profile/education/delete`, // 	删除教育经历
  accountInfo: `${CNABS_API_ADDRESS}/account/info`, // 个人信息
  articleUpdate: `${CNABS_API_ADDRESS}/account/profile/article/update`, // 	著作文章
  articleDelete: `${CNABS_API_ADDRESS}/account/profile/article/delete`, // 	删除著作文章
  endorseUpdate: `${CNABS_API_ADDRESS}/account/profile/endorse/update`, // 	添加或者移除点赞
  accountProfileUpdate: `${CNABS_API_ADDRESS}/account/profile/update`, // 编辑个人资料
  profileAvatarUpdate: `${CNABS_API_ADDRESS}/account/profile/avatar/update`, // 更新上传头像
  // 站内信收件箱
  internalMessageList: `${CNABS_API_ADDRESS}/account/internal-message/list`, // 站内信列表
  internalMessageDetail: `${CNABS_API_ADDRESS}/account/internal-message/detail`, // 站内信详情
  internalMessageDelete: `${CNABS_API_ADDRESS}/account/internal-message/delete`, // 删除站内信
  internalMessageMark: `${CNABS_API_ADDRESS}/account/internal-message/mark`, // 设为已读、未读
  internalMessageUnreadCount: `${CNABS_API_ADDRESS}/account/message/unread/count`, // 获取用户未读消息数量
  // 站内信写信
  internalMessageSend: `${CNABS_API_ADDRESS}/account/internal-message/send`, // 站内信写信发送接口
  // 已发送
  internalMessageSendList: `${CNABS_API_ADDRESS}/account/internal-message/sent-box/list`, // 站内信发件箱列表
  internalMessageSendDetail: `${CNABS_API_ADDRESS}/account/internal-message/sent-box/detail`, // 站内信发件箱详情
  internalMessageSendDelete: `${CNABS_API_ADDRESS}/account/internal-message/sent-box/delete`, // 站内信发件箱删除
  internalMessageSentReply: `${CNABS_API_ADDRESS}/account/internal-message/sent-box/reply`, // 发件箱回复

  versionList: `${CNABS_API_ADDRESS}/account/version/list`, // 版本列表
  // 后台管理
  manageVersionPager: `${CNABS_API_ADDRESS}/manage/version/pager`, // 发布日志列表
  manageVersionEdit: `${CNABS_API_ADDRESS}/manage/version/edit`, // 编辑单条发布日志
  logDetailList: `${CNABS_API_ADDRESS}/manage/version/log-detail/list`, // 获取所有发布内容列表
  versionLogEdit: `${CNABS_API_ADDRESS}/manage/version/log-detail/edit`, // 编辑单条发布内容
  logDetailDelete: `${CNABS_API_ADDRESS}/manage/version/log-detail/delete`, // 删除单条发布内容

  useInstructionList: `${CNABS_API_ADDRESS}/global/helper-files`, // 使用帮助
  replyInternalMessage: `${CNABS_API_ADDRESS}/account/internal-message/reply`, // 回复站内信
  userSearch: `${CNABS_API_ADDRESS}/account/internal-message/user/search`, // 根据用户姓名搜用户

  pointInfo: `${CNABS_API_ADDRESS}/account/point/info`, // 积分信息
  pointHistoryPager: `${CNABS_API_ADDRESS}/account/point/history/pager`, // 历史积分信息

  vipActivate: `${ACCOUNT_SERVER}/api/vip/activate`, // vip卡激活
  voteRank: `${CNABS_API_ADDRESS}/account/vote/rank2021`, // 投票
  voteAward: `${CNABS_API_ADDRESS}/account/vote/vote` // 投票情况展示
};

// 首页
export const HomePageApi = {
  homePage: `${CNABS_API_ADDRESS}/home/hot`, // 登录
  partnerImgs: `${CNABS_API_ADDRESS}/global/partner-imgs`, // 合作机构的图片
  homeAdverts: `${CNABS_API_ADDRESS}/home/adverts`, // 首页广告
  homePageRecommand: `${CNABS_API_ADDRESS}/market/daily/report`, // 首页详情
  homeExpertDynamic: `${CNABS_API_ADDRESS}/expert/dynamic`, // 专家动态
  homeFollowProduct: `${CNABS_API_ADDRESS}/account/follow/deal/pager`, // 关注产品
  newsHotHome: `${CNABS_API_ADDRESS}/home/hotnews`, // 首页热门资讯
  homeAccountInfo: `${CNABS_API_ADDRESS}/account/info`, // 首页用户基本信息
  homeMarketStatisticsList: `${CNABS_API_ADDRESS}/home/market-release-statistics/list` // 首页市场统计
};

// 市场
export const MarketApi = {
  categoryDetail: `${CNABS_API_ADDRESS}/market/category/detail`, // 市场分类详情
  categoryDownload: `${CNABS_API_ADDRESS}/market/category/download`, // 下载
  chartPrepayDefaultDownload: `${CNABS_API_ADDRESS}/market/chart/prepay-default/download`, // 资产池风险分析图数据下载
  chartWatchDurationStatsDownload: `${CNABS_API_ADDRESS}/market/negative-watch/statistic/download`, // 观察名单统计图数据下载

  indexMarketSizeInventoryChart: `${CNABS_API_ADDRESS}/market/index/market-size-inventory/chart`, // 市场总览-ABS市场发行规模与存量规模统计
  indexMarketSizeCountInventoryChart: `${CNABS_API_ADDRESS}/market/index/market-size-count-inventory/chart`, // 市场总览-ABS市场发行规模统计
  indexMarketNetFinancingChart: `${CNABS_API_ADDRESS}/market/index/market-net-financing/chart`, // 市场总览-近三年ABS市场净融资量统计
  chartMarketNetFinancing: `${CNABS_API_ADDRESS}/market/chart/market-net-financing`, // 市场总览-近三年ABS市场净融资量统计-New（带参数）
  indexMarketRepaymentChart: `${CNABS_API_ADDRESS}/market/index/market-repayment/chart`, // 市场总览-未来三年ABS市场偿付规模统计
  chartMarketRepayment: `${CNABS_API_ADDRESS}/market/chart/market-repayment`, // 市场总览-未来三年ABS市场偿付规模统计-New（带参数）
  indexSecondaryMarketVolumeChart: `${CNABS_API_ADDRESS}/market/index/secondary-market-volume/chart`, // 市场总览-二级市场交易量及流动性统计
  chartSecondaryMarketVolume: `${CNABS_API_ADDRESS}/market/chart/secondary-market-volume`, // 市场总览-二级市场交易量及流动性统计-New（带参数）
  indexCreditCouponCompareChart: `${CNABS_API_ADDRESS}/market/index/credit-coupon-compare/chart`, // 市场总览-信贷ABS市场AAA级证券发行利率与同级中期票据比较
  indexEnterpriseCouponCompareChart: `${CNABS_API_ADDRESS}/market/index/enterprise-coupon-compare/chart`, // 市场总览-企业ABS市场AAA级证券发行利率与同级公司债比较
  indexMarketSizeMonthInventoryChart: `${CNABS_API_ADDRESS}/market/index/market-size-month-inventory/chart`, // 市场总览-最近两年产品发行金额统计
  chartMarketSizeMonthInventory: `${CNABS_API_ADDRESS}/market/chart/market-size-month-inventory`, // 市场总览-最近两年产品发行金额统计-New（带参数）
  indexMarketSizeQuarterInventoryChart: `${CNABS_API_ADDRESS}/market/index/market-size-quarter-inventory/chart`, // 市场总览-最近四年各季度产品发行金额统计
  chartMarketSizeQuarterInventory: `${CNABS_API_ADDRESS}/market/chart/market-size-quarter-inventory`, // 市场总览-最近四年各季度产品发行金额统计-New（带参数）
  indexMarketDealTypeChart: `${CNABS_API_ADDRESS}/market/index/market-deal-type/chart`, // 市场总览-产品类型总览
  indexCouponCompare: `${CNABS_API_ADDRESS}/market/index/coupon-compare/chart`, // 市场总览-发行利率统计
  indexIssueTwoYearCompare: `${CNABS_API_ADDRESS}/market/index/issue-two-year-compare`, // 市场总览-发行统计两年对比
  chartIssueTwoYearCompare: `${CNABS_API_ADDRESS}/market/chart/issue-two-year-compare`, // 市场总览-发行统计两年对比-new
  indexBalanceAssetsType: `${CNABS_API_ADDRESS}/market/index/balance-assets-type`, // 市场总览-存量各资产类型统计
  chartBalanceAssetsType: `${CNABS_API_ADDRESS}/market/chart/balance-assets-type`, // 市场总览-存量各资产类型统计-new
  indexSecondaryMarketAssetVolumeChart: `${CNABS_API_ADDRESS}/market/index/secondary-market-asset-volume/chart`, // 市场总览-交易分布图
  chartSecondaryMarketAssetVolumeChart: `${CNABS_API_ADDRESS}/market/chart/secondary-market-asset-volume`, // 市场总览-交易分布图-new
  indexMarketInventoryChartDetailDownload: `${CNABS_API_ADDRESS}/market/index/market-size-count-inventory/chart-export`, // 市场总览-发行规模-年度发行-chart

  primaryMarketReleaseStatisticsList: `${CNABS_API_ADDRESS}/market/primary/market-release-statistics/list`, // 一级市场总览-ABS市场发行统计表
  primaryDealPipelineStatisticsList: `${CNABS_API_ADDRESS}/market/primary/deal-pipeline-statistics/list`, // 一级市场总览-企业ABS过会项目统计
  primaryMarketSizeChart: `${CNABS_API_ADDRESS}/market/primary/market-size/chart`, // 一级市场总览-发行规模统计
  primaryMarketBalanceChart: `${CNABS_API_ADDRESS}/market/primary/market-balance/chart`, // 一级市场总览-存量规模统计
  primaryIssueRateChart: `${CNABS_API_ADDRESS}/market/primary/issue-rate/chart`, // 一级市场总览-信贷ABS产品发行利差发布
  primaryIssueSpreadChart: `${CNABS_API_ADDRESS}/market/primary/issue-spread/chart`, // 一级市场总览-企业ABS产品发行利差发布
  primaryTopProductList: `${CNABS_API_ADDRESS}/market/primary/top-product/list`, // 一级市场总览-最新进入发行期的产品(前十)
  primaryTopExpertList: `${CNABS_API_ADDRESS}/market/primary/top-expert/list`, // 一级市场总览-市场专家(前十)

  chartOrganrank: `${CNABS_API_ADDRESS}/market/chart/organrank`, // 发行统计-发起机构（前十排名）
  chartSize: `${CNABS_API_ADDRESS}/market/chart/size`, // 发行统计-发行规模
  // chartMarketSizeInventory: `${CNABS_API_ADDRESS}/market/chart/market-size-inventory`, // 发行统计-发行规模-NEW
  chartCouponCompare: `${CNABS_API_ADDRESS}/market/chart/coupon-compare`, // 发行统计-发行利率分布
  chartIssueRate: `${CNABS_API_ADDRESS}/market/chart/issue-rate`, // 发行统计-发行利差分布
  chartFeeDistribution: `${CNABS_API_ADDRESS}/market/chart/fee-distribution`, // 产品证券-费率分布
  chartTotalOfferingDistribute: `${CNABS_API_ADDRESS}/market/chart/total-offering-distribute`, // 产品证券-发行金额分布
  chartSubDistribution: `${CNABS_API_ADDRESS}/market/chart/sub-distribution`, // 产品证券-次级证券占比分布（次级厚度）
  chartNoteRemainingTermDistribution: `${CNABS_API_ADDRESS}/market/chart/note-remaining-term-distribution`, // 产品证券-剩余年限分布（证券期限）

  chartBalance: `${CNABS_API_ADDRESS}/market/chart/balance`, // 年末存量
  chartPrepayChrono: `${CNABS_API_ADDRESS}/market/chart/prepay-chrono`, // 资产池累计提前偿还率走势图
  chartDefaultChrono: `${CNABS_API_ADDRESS}/market/chart/default-chrono`, // 资产池累计违约率走势图
  chartAssetCountDistribution: `${CNABS_API_ADDRESS}/market/chart/asset-count-distribution`, // 资产个数分布
  chartADistribution: `${CNABS_API_ADDRESS}/market/chart/a-distribution`, // 优先级占比分布
  chartPrepaymentRateDistribution: `${CNABS_API_ADDRESS}/market/chart/prepayment-rate-distribution`, // 提前偿还率分布
  chartOrigRegionDistribution: `${CNABS_API_ADDRESS}/market/chart/orig-region-distribution`, // 地域分布
  chartOrigIndustryDistribution: `${CNABS_API_ADDRESS}/market/chart/orig-industry-distribution`, // 行业分布
  chartAppendDistributeInfo: `${CNABS_API_ADDRESS}/market/chart/append-distribute-info`, // 担保情况分布

  newsList: `${CNABS_API_ADDRESS}/market/news/pager`, // 国内新闻
  newsdetails: `${CNABS_API_ADDRESS}/market/news/detail`, // 国内新闻详情
  hotNewsList: `${CNABS_API_ADDRESS}/market/news/hot`, // 新闻列表块
  dailyReportDetails: `${CNABS_API_ADDRESS}/market/daily/report`, // 日报详情
  dailyHotNewsList: `${CNABS_API_ADDRESS}/market/daily/hot`, // 新闻列表块
  dailyReleaseStatisticsList: `${CNABS_API_ADDRESS}/market/daily/market-release-statistics/list`, // 日报发行统计
  factorylist: `${CNABS_API_ADDRESS}/market/report/pager`, // 研报工厂
  factoryDownload: `${CNABS_API_ADDRESS}/market/report/download`, // 研报工厂下载
  fistWindCloudList: `${CNABS_API_ADDRESS}/market/first-deal/pager`, // 首单风云榜
  firstDealshow: `${CNABS_API_ADDRESS}/market/first-deal/may-apply`, // 首单产品提名按钮是否显示
  firstDeal: `${CNABS_API_ADDRESS}/market/first-deal/apply`, // 首单产品提名

  indexDownload: `${CNABS_API_ADDRESS}/market/cnabs-index/download`, // 指数编制白皮书下载
  indexExport: `${CNABS_API_ADDRESS}/market/cnabs-index/export`, // 指数数据下载
  indexTrendList: `${CNABS_API_ADDRESS}/market/cnabs-index/trend/list`, // 指数表现表格
  indexReturnChart: `${CNABS_API_ADDRESS}/market/cnabs-index/return/chart`, // 投资总回报指数图
  indexYieldChart: `${CNABS_API_ADDRESS}/market/cnabs-index/yield/chart`, // 投资收益率指数图
  indexWalChart: `${CNABS_API_ADDRESS}/market/cnabs-index/wal/chart`, // 信贷ABS发行统计-存量规模统计

  newsExport: `${CNABS_API_ADDRESS}/market/news/export`, // 政策法规下载
  // 观察名单
  amount: `${CNABS_API_ADDRESS}/market/negative-watch-new/amount`, // 发行前后数据总览
  event: `${CNABS_API_ADDRESS}/market/negative-watch-new/eventYears`,
  regionDistribution: `${CNABS_API_ADDRESS}/market/negative-watch-new/regionDistribution`,
  orgNatureDistribution: `${CNABS_API_ADDRESS}/market/negative-watch-new/orgNatureDistribution`, // 发行前后数据总览
  productTypeDistribution: `${CNABS_API_ADDRESS}/market/negative-watch-new/productTypeDistribution`, // 发行前后数据总览

  yearGramChart: `${CNABS_API_ADDRESS}/market/negative-watch-new/year-gram/chart`, // 发行前后观察名单占发行产品比例走势
  productChart: `${CNABS_API_ADDRESS}/market/negative-watch-new/product/chart`, // 发行前后各市场产品数量统计
  eventMainChart: `${CNABS_API_ADDRESS}/market/negative-watch-new/event-main/chart`, // 发行前后各事件主体类型数量统计
  eventChart: `${CNABS_API_ADDRESS}/market/negative-watch-new/event/chart`, // 发行前后各事件类型数量统计

  watchList: `${CNABS_API_ADDRESS}/market/negative-watch-new/pager`,
  watchEventList: `${CNABS_API_ADDRESS}/market/negative-watch-new/events`,
  exportList: `${CNABS_API_ADDRESS}/market/negative-watch-new/export`,

  heatGramSelects: `${CNABS_API_ADDRESS}/market/negative-watch-new/heat-gram/selects`, // 观察名单热力图选择项
  heatGramChart: `${CNABS_API_ADDRESS}/market/negative-watch-new/heat-gram/chart`, // 观察名单热力图

  // 评级分析
  ratingAgency: `${CNABS_API_ADDRESS}/market/rating/agency`, // 评级机构
  combinationChart: `${CNABS_API_ADDRESS}/market/rating/combination/chart`, // 原始评级比较图
  transitionChart: `${CNABS_API_ADDRESS}/market/rating/transition/chart`, // 评级跃迁图
  ratingList: `${CNABS_API_ADDRESS}/market/rating/list`, // 近期评级变化
  upgradeChart: `${CNABS_API_ADDRESS}/market/rating/upgrade/chart`, // 评级变化分布图
  // 数据绘图
  drawingChart: `${CNABS_API_ADDRESS}/data/drawing/chart`,

  prepayDefaultDownloadPoints: `${CNABS_API_ADDRESS}/market/chart/prepay-default/download/points`, // 资产历史违约率下载的一个获取数量的接口

  voteRank: `${CNABS_API_ADDRESS}/account/vote/rank`, // 获取投票排名
  myVoteRank: `${CNABS_API_ADDRESS}/account/vote/rank/self`, // 获取我的投票排名

  // 海报
  posterPager: `${CNABS_API_ADDRESS}/market/poster/pager`, // 获取海报列表
  posterAdd: `${CNABS_API_ADDRESS}/market/poster/add`, // 添加海报
  posterChangeLikeStatus: `${CNABS_API_ADDRESS}/market/poster/change-like-status/`, // 海报点赞与取消点赞
  posterDelete: `${CNABS_API_ADDRESS}/market/poster/delete/`, // 删除海报
  posterPagerAdmin: `${CNABS_API_ADDRESS}/market/poster/pager/admin`, // 后台管理员查看海报列表
  posterChangeApprovalStatus: `${CNABS_API_ADDRESS}/market/poster/change-approval-status/`, // 后台管理员审核海报

  // 路演
  projectTypeOptions: `${CNABS_API_ADDRESS}/market/roadshow/project-type-options`, // 资产类型下拉选项
  roadshowPager: `${CNABS_API_ADDRESS}/market/roadshow/pager`, // 路演列表
  roadshowAdminPager: `${CNABS_API_ADDRESS}/market/roadshow/pager/admin`, // 路演列表
  roadshowAdd: `${CNABS_API_ADDRESS}/market/roadshow/add`, // 添加路演
  roadshowDelete: id => `${CNABS_API_ADDRESS}/market/roadshow/delete/${id}`, // 删除路演
  roadshowDetail: id => `${CNABS_API_ADDRESS}/market/roadshow/${id}`, // 路演详情
  roadshowUpdate: `${CNABS_API_ADDRESS}/market/roadshow/update`, // 更新路演详情
  roadshowChange: id => `${CNABS_API_ADDRESS}/market/roadshow/change-approval-status/${id}`, // 更新路演详情
  roadshowMessage: id => `${CNABS_API_ADDRESS}/market/roadshow/message/${id}`, // 统计共同信息
  roadshowDownload: id => `${CNABS_API_ADDRESS}/market/roadshow/download/${id}`, // 路演下载

  // 资产类型，子类型
  projectTypeList: `${CNABS_API_ADDRESS}/market/roadshow/project-type/list`, // 获取资产类型
  projectTypeAdd: `${CNABS_API_ADDRESS}/market/roadshow/project-type/add`, // 获取资产类型
  projectTypeUpdate: `${CNABS_API_ADDRESS}/market/roadshow/project-type/update`, // 获取资产类型
  projectTypeDelete: id => `${CNABS_API_ADDRESS}/market/roadshow/project-type/delete/${id}` // 获取资产类型
};

// 专家
export const ExpertApi = {
  squareExpertList: `${CNABS_API_ADDRESS}/expert/square/list`, // 专家广场专家列表
  expertDynamic: `${CNABS_API_ADDRESS}/expert/dynamic`, // 专家动态
  expertDynamicIgnore: `${CNABS_API_ADDRESS}/expert/dynamic/ignore`, // 忽略专家动态
  expertResumeLink: `${CNABS_API_ADDRESS}/expert/resume/link` // 专家链
};

// 定价
export const PriceApi = {
  priceDetailChart: `${CNABS_API_ADDRESS}/pricing/security/price/detail`, // 证券交易定价
  cashflowDetailChart: `${CNABS_API_ADDRESS}/pricing/security/cashflow/detail`, // 证券现金流
  securityCore: `${CNABS_API_ADDRESS}/pricing/security/core`, // 证券核心信息
  securityDetail: `${CNABS_API_ADDRESS}/pricing/security/detail`, // 证券详细信息
  securityPriceDownload: `${CNABS_API_ADDRESS}/pricing/security/price/download`, // 证券交易定价下载
  securityIssueBody: `${CNABS_API_ADDRESS}/pricing/security/organization/detail`, // 发行主体基本信息
  securityCreditInfo: `${CNABS_API_ADDRESS}/pricing/security/credit-info`, // 增信信息

  cashflowDetail: `${CNABS_API_ADDRESS}/pricing/cashflow/detail`, // 现金流总览
  cashflowDownload: `${CNABS_API_ADDRESS}/pricing/cashflow/download`, // 现金流下载
  cashflowDownloadDemo: `${CNABS_API_ADDRESS}/pricing/cashflow/download-demo`, // 现金流下载模板
  cashflowUpload: `${CNABS_API_ADDRESS}/pricing/cashflow/upload`, // 现金流上传
  cashflowDelete: `${CNABS_API_ADDRESS}/pricing/cashflow/delete`, // 现金流删除
  cashflowDifferentChart: `${CNABS_API_ADDRESS}/pricing/cashflow/different`, // 现金流对比
  cashflowRecoveryChart: `${CNABS_API_ADDRESS}/pricing/cashflow/cashflow-recovery`, // 现金流回收分配

  // 交易定价
  tradepriceResult: `${CNABS_API_ADDRESS}/pricing/tradeprice/result`, // 定价结果信息
  tradepriceChart: `${CNABS_API_ADDRESS}/pricing/tradeprice/chart`, // 定价结果与图表信息
  tradepriceCalcdays: `${CNABS_API_ADDRESS}/pricing/tradeprice/calcdays`, // 交易结算日期交互
  tradepriceCalculate: `${CNABS_API_ADDRESS}/pricing/tradeprice/price-calculate`, // 计算
  tradepriceResultDownload: `${CNABS_API_ADDRESS}/pricing/tradeprice/result/download`, // 定价结果下载
  tradepriceUserCashflowStatusUpdate: `${CNABS_API_ADDRESS}/pricing/tradeprice/user-cashflow-status-update`, // 用户现金流状态更新
  // 收益率
  yieldCurveDetailChart: `${CNABS_API_ADDRESS}/pricing/yieldrate/yieldcurve/detail`, // 收益率曲线图
  spreadModelDetailChart: `${CNABS_API_ADDRESS}/pricing/yieldrate/spreadmodel/detail`, // 利差模型
  barDetailChart: `${CNABS_API_ADDRESS}/pricing/yieldrate/bar/detail`, // 驱动因子利差模型
  lineSeriesDetailChart: `${CNABS_API_ADDRESS}/pricing/yieldrate/lineseries/detail`, // 模型计算实际利差

  customList: `${CNABS_API_ADDRESS}/pricing/scenario/custom/list`, // 获取用户情景列表
  paramList: `${CNABS_API_ADDRESS}/pricing/scenario/custom/param/list`, // 获取产品条件参考参数
  paramSummaryList: `${CNABS_API_ADDRESS}/pricing/scenario/custom/param/summarylist`, // 获取产品累计参考参数
  customSave: `${CNABS_API_ADDRESS}/pricing/scenario/custom/save`, // 新增情景
  customDelete: `${CNABS_API_ADDRESS}/pricing/scenario/custom/delete`, // 删除情景

  // 情景分析
  pricingScenarioList: `${CNABS_API_ADDRESS}/pricing/scenario/list`, // 情景列表和分析结果
  scenarioCalculate: `${CNABS_API_ADDRESS}/pricing/scenario/calculate`, // 情景计算
  cashflowVerify: `${CNABS_API_ADDRESS}/pricing/scenario/cashflow/verify`, // 现金流验证
  cashflowSave: `${CNABS_API_ADDRESS}/pricing/scenario/cashflow/save`, // 现金流保存
  scenarioCashflowDownload: `${CNABS_API_ADDRESS}/pricing/scenario/cashflow/download`, // 现金流下载
  curveHandle: `${CNABS_API_ADDRESS}/pricing/curve/handle` // 曲线功能
};

// 教育
export const EducationApi = {
  educationPager: `${CNABS_API_ADDRESS}/education/pager`, // 研究专区
  educationAdd: `${CNABS_API_ADDRESS}/education/article/add`, // 后台管理添加文章
  educationEdit: `${CNABS_API_ADDRESS}/education/article/edit`, // 后台管理编辑文章
  articleList: `${CNABS_API_ADDRESS}/education/list`, // 研究专区管理页面的文章list
  articleDelete: `${CNABS_API_ADDRESS}/education/article/delete`, // 研究专区管理页面的删除文章

  // 行业会议
  conferenceList: `${CNABS_API_ADDRESS}/market/conference/list`, // 用户会议列表
  conferenceDetail: `${CNABS_API_ADDRESS}/market/conference/detail`, // 会议详情

  conferenceUserInfo: `${CNABS_API_ADDRESS}/market/conference/user/info`, // 获取用户信息
  conferenceUserUpdate: `${CNABS_API_ADDRESS}/market/conference/user/update`, // 更改用户信息
  conferenceApply: `${CNABS_API_ADDRESS}/market/conference/apply`, // 提交报名

  conferenceListSelf: `${CNABS_API_ADDRESS}/market/conference/list/self`, // 我的参会
  // 汇菁奖
  huijingAwardApplyPager: `${CNABS_API_ADDRESS}/account/huijing-award-apply/pager`, // 汇菁奖申报记录
  huijingAwardOptions: `${CNABS_API_ADDRESS}/account/huijing-award-apply/award-options`, // 汇菁奖奖项类型
  huijingAwardApplyAdd: `${CNABS_API_ADDRESS}/account/huijing-award-apply/add` // 提交汇菁奖申报
};

// 融资
export const FinanceApi = {
  requirementInit: `${CNABS_API_ADDRESS}/finance/requirement/initialization`, // 输入需求初始化
  requirementDownload: `${CNABS_API_ADDRESS}/finance/requirement/download`, // 下载基础资产模板
  requirementExcel: `${CNABS_API_ADDRESS}/finance/requirement/upload-excel`, // 上传基础资产
  requirementCard: `${CNABS_API_ADDRESS}/finance/requirement/upload-card`, // 上传名片
  requirementEntering: `${CNABS_API_ADDRESS}/finance/requirement/entering`, // 需求录入
  requirementDetail: `${CNABS_API_ADDRESS}/finance/requirement/detail`, // 提交详情
  requirementList: `${CNABS_API_ADDRESS}/finance/requirement/list`, // 提交记录

  upload: `${CNABS_API_ADDRESS}/finance/file/upload`, // 上传
  uploadList: `${CNABS_API_ADDRESS}/finance/file/list`, // 上传记录
  financefileDownload: `${CNABS_API_ADDRESS}/finance/file/download`, // 模版下载
  backstagePager: `${CNABS_API_ADDRESS}/finance/backstage/pager`, // 后台信息列表
  backstageDownload: `${CNABS_API_ADDRESS}/finance/backstage/download`, // 后台下载
  backstageUpdate: `${CNABS_API_ADDRESS}/finance/backstage/update` // 后台更新
};

// 后台管理
export const ManageApi = {
  // 站内信相关权限
  internalMessage: {
    addPermission: `${CNABS_API_ADDRESS}/manage/internal-message/add/permission`, // 增加管理权限
    deletePermission: `${CNABS_API_ADDRESS}/manage/internal-message/delete/permission`, // 移除管理权限
    getPermission: `${CNABS_API_ADDRESS}/manage/internal-message/get/permission`, // 获取管理权限
    list: `${CNABS_API_ADDRESS}/manage/internal-message/list`, // 获取所有站内信数据
    deleteMessage: `${CNABS_API_ADDRESS}/manage/internal-message/delete/message`, // 删除站内信
    getUserInfo: `${CNABS_API_ADDRESS}/manage/internal-message/permission/user/info`, // 获取用户信息
    sendMessageAppointUser: `${CNABS_API_ADDRESS}/manage/internal-message/send/appoint-user`, // 指定用户发送站内信
    sendMessageAll: `${CNABS_API_ADDRESS}/manage/internal-message/send/all`, // 发送站内信给所有用户
    userCount: `${CNABS_API_ADDRESS}/manage/internal-message/user/count` // 获取所有用户数量
  },

  advertList: `${CNABS_API_ADDRESS}/manage/advert/list`, // 广告列表
  advertOrder: `${CNABS_API_ADDRESS}/manage/advert/order`, // 排序号下拉框
  advertShownChange: `${CNABS_API_ADDRESS}/manage/advert/shown_change`, // 是否显示
  advertInsert: `${CNABS_API_ADDRESS}/manage/advert/insert`, // 添加
  advertUpdate: `${CNABS_API_ADDRESS}/manage/advert/update`, // 修改
  advertDelete: `${CNABS_API_ADDRESS}/manage/advert/delete`, // 删除

  homeExpertUpdate: `${CNABS_API_ADDRESS}/manage/expert/update`, // 首页专家刷新

  hotDealsList: `${CNABS_API_ADDRESS}/market/daily/hot-deals-config`, // 市场热门产品列表
  addHotDeal: `${CNABS_API_ADDRESS}/market/daily/hot-deals-config/add`, // 添加
  editHotDeal: `${CNABS_API_ADDRESS}/market/daily/hot-deals-config/update`, // 编辑
  deleteHotDeal: `${CNABS_API_ADDRESS}/market/daily/hot-deals-config/delete`, // 删除
  refreshHotDeals: `${CNABS_API_ADDRESS}/market/daily/hot-deals-config/refresh`, // 首页市场热门产品刷新

  useHelpDocList: `${CNABS_API_ADDRESS}/manage/helper-files/list`, // 使用帮助文档列表
  useHelpDocDelete: `${CNABS_API_ADDRESS}/manage/helper-files/delete`, // 使用帮助文档删除
  updateUseHelpDoc: `${CNABS_API_ADDRESS}/manage/helper-files/update` // 添加编辑使用帮助文档
};

// API
export const OpenApi = {
  myPage: `${CNABS_API_DATA_ADDRESS}/apis/my/page`, // 我的数据页面
  category: `${CNABS_API_DATA_ADDRESS}/apis/category`, // 获取API分类目录
  apiList: `${CNABS_API_DATA_ADDRESS}/apis/page`, // 获取API列表(带分页)
  apiTry: apiId => `${CNABS_API_DATA_ADDRESS}/apis/${apiId}/try`, // 当前用户试用该api
  apiDetail: apiId => `${CNABS_API_DATA_ADDRESS}/apis/${apiId}`, // 单个Api详情
  apiPat: `${CNABS_API_DATA_ADDRESS}/apis/pat` // 单个Api详情
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/config/api.ts